import styled, { css } from 'styled-components';
import { Item, Name as NameBase } from '../../index.view';

interface MenuDetailProps {
  alignment?: string;
}

const MenuItemWrapper = styled(Item)`
  align-items: flex-start;
  cursor: pointer;
  padding: 0;
`;

const MenuDetail = styled.div<MenuDetailProps>`
  display: flex;
  justify-content: ${({ alignment = 'center' }) => alignment};
`;

const MenuWithCondiments = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  word-break: break-word;
`;

const Name = styled(NameBase)`
  padding-left: 0;
  line-height: initial;
  margin: 6px 0;
  max-width: 80%;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('xs')} {
      max-width: 68%;
    }
  `}
`;

const Amount = styled(NameBase)`
  padding-right: 10px;
`;

export { MenuItemWrapper, MenuDetail, MenuWithCondiments, Name, Amount };
